import React from 'react';
import { Routes, Route } from 'react-router-dom';
import App from '../App';
import PlanFullscreen from './PlanFullscreen';

const AppRouter = ({ isDevMode, onExitDevMode, isAuthenticated }) => {
  return (
    <Routes>
      <Route path="/plan-fullscreen" element={<PlanFullscreen />} />
      <Route path="/*" element={<App isDevMode={isDevMode} onExitDevMode={onExitDevMode} isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

export default AppRouter;
